import { render, staticRenderFns } from "./SlotModule.vue?vue&type=template&id=0a2c236e&scoped=true&"
import script from "./SlotModule.vue?vue&type=script&lang=js&"
export * from "./SlotModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c236e",
  null
  
)

export default component.exports